import axios from "axios";

const createUser = async (token, values) => {
  const path = `${process.env.REACT_APP_BACKEND_API_URL}/users`;
  try {
    const response = await axios.post(path, values, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
    return response
    ;
  } catch (error) {
    console.log(error.response);
    return error.status;
  }
};

export default createUser;